import React from 'react';
import SeoMeta from '../../platform/components/common/seoMeta';
import BusinessLandingPage from '../../platform/pages/business/businessPage/businessLandingPage';

export default function TimelyHomePage() {
  return <>
    <SeoMeta title="Timely365 | Scheduling that makes room for people" description="Share your availability, let people book a time, and keep appointments organized with Timely365." url="/" />
    <BusinessLandingPage />
  </>;
}
